export default __webpack_public_path__ + "static/media/next.7918dd7b.svg";